<template>
  <b-row>
    <b-col
      md="6"
      class="p-4 mx-auto"
    >
      <b-card v-if="mode=== 'resend-success'">
        <b-card-header class="pl-0 pt-0 mb-2 flex-column">
          <feather-icon
            icon="CheckCircleIcon"
            size="70"
            class="mb-1 success"
            color="#28c76f"
          />
          <b-card-title>{{ $t('Email Sent') }}</b-card-title>
        </b-card-header>
        <b-card-body>
          <p style="text-align: center !important">
            {{ $t('messages.confirmation-email', { email: email }) }}
          </p>
          <p style="text-align: center !important">
            {{ $t('messages.verify-info') }}
          </p>
          <div class="text-center">
            <b-button
              variant="primary"
              class="mb-2 btn-sm-block mt-1"
              :to="{path:'/'}"
            >
              {{ $t('Back to Home') }}
            </b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card v-else-if="mode=== 'already-registered'">
        <b-card-header class="pl-0 pt-0 mb-2 flex-column">
          <feather-icon
            icon="AlertCircleIcon"
            size="70"
            class="mb-1 success"
            color="#ff9900"
          />
          <b-card-title>{{ $t('messages.already-registered') }}</b-card-title>
        </b-card-header>
        <b-card-body>
          <p style="text-align: center !important">
            {{ $t('messages.already-registered-info', { email: email}) }}
          </p>
          <div class="text-center">
            <b-button
              variant="primary"
              class="mb-2 btn-sm-block mt-1"
              :to="{path:'/'}"
            >
              {{ $t('Back to Home') }}
            </b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card
        v-else
        class="resend-card"
      >
        <b-card-header class="pl-0 pt-0 mb-2 flex-column">
          <feather-icon
            icon="AlertCircleIcon"
            size="70"
            color="#ff9900"
            class="mb-1"
          />
          <b-card-title class="text-center">
            <span style="font-size:2rem; font-weight:bold; color:#ff9900;">
              Oops!
            </span>
            <br>
            <span style="font-size:1.1rem;">
              {{ $t('Your email address has not been verified yet.') }}
              <br>
              <span style="color:#888;">
                {{ $t('If you did not receive the verification email, or if verification failed, please click the button below to send it again.') }}
              </span>
            </span>
          </b-card-title>
        </b-card-header>

        <b-form-group :label="$t('labels.resend-verification')">
          <b-form-input
            v-model="email"
            disabled
          />
        </b-form-group>

        <b-button
          variant="outline-danger"
          class="float-left"
          :to="{ path: '/login' }"
        >
          {{ $t('Back to Login') }}
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          :disabled="(isProcessing || isSent)"
          @click="resendVerification"
        >
          <b-spinner
            v-show="isProcessing"
            small
          />
          {{ $t('Resend') }}
        </b-button>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  VBModal, BFormGroup, BFormInput, BSpinner, BButton,
  BCard, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import { required } from '@validations'
import useApollo from '@/plugins/graphql/useApollo'

const defaultForm = () => ({
  id: null,
  name: '',
  type: '0',
  password: '',
  email: '',
  address: '',
  password_confirmation: '',
  company: {
    name: '',
    email: '',
    address: '',
  },
})
export default {
  components: {
    BFormInput,
    BFormGroup,
    BCard,
    BSpinner,
    BButton,
    BCardHeader,
    BCardTitle,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      required,
      // email,
      title: 'Create Company',
      isProcessing: false,
      form: {
        ...defaultForm(),
      },
      mode: '',
      isSent: false,
      token: this.$route.query.token,
      email: this.$route.query.email,
      passwordFieldType: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordStrength() {
      return this.PASSWORD_STRENGTH(this.form.password)
    },
  },
  mounted() {
    // localStorage.removeItem('userData')
    // localStorage.removeItem('accessToken')
    localStorage.clear()
  },
  methods: {

    resendVerification() {
      this.isProcessing = true
      useApollo.auth.resendVerificationEmail({
        email: this.email,
      }).then(response => {
        this.showInfoMessage({
          title: 'Email Sent',
          message: response.data.resendVerificationEmail.message,
        })
        this.isProcessing = false
        // eslint-disable-next-line eqeqeq
        if (response.data.resendVerificationEmail.status !== 'USER_ALREADY_REGISTERED') {
          this.mode = 'resend-success'
        } else {
          this.mode = 'already-registered'
        }

        this.isSent = true
      })
    },
  },
}
</script>
